export const RequiredAsterisk = () => (
  <span className="pl-0.5 text-ds-danger-400">*</span>
);
